import { Card, CardMedia } from "@mui/material";

type ListingCardMediaProps = { resizedImage?: string };

export const ListingCardMedia = ({ resizedImage }: ListingCardMediaProps) => {
  return (
    <Card className="rounded-[1.75rem]">
      <CardMedia
        className="aspect-video"
        component="img"
        image={resizedImage}
      />
    </Card>
  );
};
